import { render, staticRenderFns } from "./ParticlePage.vue?vue&type=template&id=d381d7d0&"
import script from "./ParticlePage.vue?vue&type=script&lang=js&"
export * from "./ParticlePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports